export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Formats time duration in seconds to format
 * - Verbose: "Xh Ym Zs" or "Xm Ys"
 * - Compact: "H:MM:SS" or "M:SS"
 * @param seconds - Time in seconds
 * @returns Formatted string
 */
export const formatDuration = (
  seconds: number,
  verbose: boolean = false
): string => {
  if (isNaN(seconds)) return verbose ? '0s' : '0:00';

  seconds = Math.floor(seconds);

  if (seconds < 60)
    return verbose ? `${seconds}s` : `0:${seconds.toString().padStart(2, '0')}`;

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (minutes < 60)
    return verbose
      ? `${minutes}m ${secs}s`
      : `${minutes}:${secs.toString().padStart(2, '0')}`;

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return verbose
    ? `${hours}h ${mins}m ${secs}s`
    : `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Formats a timestamp in seconds to MM:SS.SS format
 * @param seconds - Time in seconds
 * @returns Formatted string in MM:SS.SS format, or --:-- if undefined
 */
export const formatTimestamp = (seconds?: number): string => {
  if (seconds === undefined) return '--:--';
  const mins = Math.floor(seconds / 60);
  const secs = (seconds % 60).toFixed(2).padStart(5, '0');
  return `${mins}:${secs}`;
};

/**
 * Formats a date timestamp to localized string
 * @param timestamp - ISO date string
 * @returns Localized date and time string
 */
export const formatDateTimestamp = (timestamp: string): string => {
  return new Date(timestamp).toLocaleString();
};
